import { render, staticRenderFns } from "./Ramal.vue?vue&type=template&id=a572dd2e&"
import script from "./Ramal.vue?vue&type=script&lang=js&"
export * from "./Ramal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports